export const FirebaseConfig = {
	"projectId": "truckgo-app",
	"appId": "1:18038003151:web:2718ec4d9a12f02b45aeba",
	"databaseURL": "https://truckgo-app-default-rtdb.firebaseio.com",
	"storageBucket": "truckgo-app.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyD0ND_Sl1DB4i4PNwB1lSmOj08EEPD2nhI",
	"authDomain": "truckgo-app.firebaseapp.com",
	"messagingSenderId": "18038003151",
	"measurementId": "G-3KE9T4WPFK"
};